import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import TrDashboardHeader from "../../../components/common/TrainerDashboardHeader";
import TrainerSidenav from "../../../components/trainer/courses/Sidenav";
import rarrow from "../../../img/rarrow.svg";
import trainees from "../../../img/trainees.svg";
import { IUser } from "../../../models/auth.model";
import { ICalendarEvents } from "../../../models/calendar-model";
import { ICourseTrainees } from "../../../models/course/course-trainees.model";
import UserAdminService from "../../../services/admin/admin_users.service";
import { getLocalUserProfile } from "../../../services/auth.service";
import coursesService from "../../../services/courses.service";
import calendarService from "../../../services/trainer/calendar.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import { getNexMonth, getPreviousMonth } from "../../../utils/dates";
import trainerRoutes from "../routes";

export const ExcelDataExport = [
  {
    "S/N": "1",
    Name: "Bolaji Muili",
    "Trainee Code": "1674469180",
    "Checked In Time": "10:20:00",
    Present: "true",
  },
];

const MyTrainees = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const params = useParams();
  const course_id: any = params.course_id;
  const toast = useToast();
  const location = useLocation();
  const [traineesList, setTrainees] = useState<ICourseTrainees[]>();
  const [calendarevents, setCalendarEvents] = useState<ICalendarEvents[]>();
  const [user, setUser] = useState<IUser>();
  const [loading, setLoading] = useState(true);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const inputProof = useRef<HTMLInputElement | null>(null);
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [filename, setFilename] = useState("");
  const [proofFile, setproofFile] = useState<File | undefined>();
  const [fileproofname, setFileProofname] = useState("");
  const [cal_id, setcal_id] = useState("");
  const [availableCourseID, setAvailableCourseID] = useState<string>();
  const navigate = useNavigate();

  const courseName: null | string = localStorage.getItem("courseName");

  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });
  const modalSize = useBreakpointValue({ base: "xs", sm: "md", md: "lg" });
  const [formErrors, setFormErrors] = useState({
    cal_id: "",
    templateFile: "",
  });

  const menuLinks = [
    {
      text: "Course Information",
      route: trainerRoutes.trainerCourses.CourseInformationLink(course_id),
      keywords: ["course-information"],
    },
    {
      text: "Announcements",
      route: trainerRoutes.trainerCourses.AnnouncementLink(course_id),
      keywords: ["announcement"],
    },
    {
      text: "My trainees",
      route: trainerRoutes.trainerCourses.TraineesLink(course_id),
      keywords: ["trainees", "my-attendance-list"],
    },
    {
      text: "Event Scheduler",
      route: trainerRoutes.trainerCourses.CalendarLink(course_id),
      keywords: ["calendar"],
    },
    {
      text: "Discussions",
      route: trainerRoutes.trainerCourses.DiscussionLink(course_id),
      keywords: ["discussion", "discussions"],
    },
    {
      text: "Assessments",
      route: trainerRoutes.trainerCourses.AssignmentsLink(course_id),
      keywords: ["assessments", "assignment"],
    },
    {
      text: "Results",
      route: trainerRoutes.trainerCourses.ResultLink(course_id),
      keywords: ["results", "result"],
    },
    {
      text: "Resources",
      route: trainerRoutes.trainerCourses.ResourcesLink(course_id),
      keywords: ["resource", "resources"],
    },
  ];

  const activeLink = (link: string, keywords: string[]) => {
    const style = {
      borderColor: "white",
      borderLeft: "",
      bgColor: "white",
      textColor: "#9E9E9E",
    };

    if (keywords.some((keyword) => location.pathname.includes(keyword))) {
      style.borderColor = "#EC3337";
      style.borderLeft = "3px Solid";
      style.bgColor = "#FFFAFA";
      style.textColor = " #EC3337";
    }

    return style;
  };

  useEffect(() => {
    const user = getLocalUserProfile();
    if (user) {
      const date = new Date();
      calendarService
        .getCalendar(user.id, getPreviousMonth(date), getNexMonth(date))
        .then((res) => {
          setCalendarEvents(res.data);
        });
      setUser(user);
    }

    if (course_id) {
      coursesService
        .getAvailableCourses()
        .then((response) => {
          const available_course = response.find(
            (each) => each.course.uuid == course_id
          );
          if (available_course) {
            console.log(available_course, "Available courses");
            setAvailableCourseID(available_course?.course_id.toString());
            trainercoursesService
              .getCourseTrainees(
                course_id,
                available_course?.session_id.toString(),
                available_course?.term_id.toString()
              )
              .then((res) => {
                setTrainees(res.data);
           
              });
          }
        })
        .catch((err) => err).finally(() => {
          setLoading(false); // set loading to false for no available course
        });
    }
  }, [course_id]);

  useEffect(() => {
    console.log(availableCourseID, loading)
  },[])

  const downloadAttendanceTemplate = () => {
    // available course id
    if (availableCourseID) {
      UserAdminService.downloadAttendanceTemplate(availableCourseID)
        .then((res) => {
          // setTemplateData(res);
          const staticFilename = "Attendance Template"; // Replace "your_static_filename" with your desired filename
          const outputFilename = `${staticFilename}.xlsx`;

          const url = URL.createObjectURL(new Blob([res]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();

          // Clean up the URL and link
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
          toast({
            title: "Template Download",
            description: "Template downloaded successfully",
            status: "success",
            duration: 2000,
          });
        })
        .catch((err: any) => {
          toast({
            title: "Template Download",
            description: `${err.response.data.message}`,
            status: "error",
            duration: 2000,
          });
        });
    } else {
      toast({
        title: "Course not available for this session",
        description: "You can't download attendance for this session",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files;
    if (newFiles && newFiles.length > 0) {
      const file = newFiles.item(0) as File;
      const fileName = newFiles.item(0)?.name as string;
      const fileType = file.type;

      if (
        fileType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFilename(fileName);
        setbatchFile(file);
      } else {
        setFilename("");
        setbatchFile(undefined);
        toast({
          title: "Invalid File Type",
          description: "Only Excel (.xlsx) files are supported.",
          status: "error",
        });
      }
    } else {
      setFilename("");
      setbatchFile(undefined);
    }
  };

  const validateForm = () => {
    let isValid = true;
    const errors: any = {
      cal_id: "",
      templateFile: "",
    };

    if (!cal_id) {
      isValid = false;
      errors.cal_id = "Please select a calendar event";
    }

    if (!batchFile) {
      isValid = false;
      errors.templateFile = "Attendance file is required";
    }

    setFormErrors(errors);

    return isValid;
  };

  const goToAttendance = () => {
    if (course_id)
      navigate(trainerRoutes.trainerCourses.AttendanceListLink(course_id));
  };

  const uploadAttendance = async () => {
    if (availableCourseID) {
      const isValid = validateForm();
      if (batchFile && user && isValid) {
        const formData = new FormData();
        formData.append("template", batchFile);
        formData.append("trainer_id", user?.id?.toString());
        formData.append("calendar_id", cal_id);
        try {
          const schedule_res = await trainercoursesService.uploadAttendance(
            formData
          );
          if (schedule_res) {
            toast({
              title: "Attendance",
              description: `${schedule_res.message}`,
              status: "success",
            });
            onClose();
            //setReload(!reload)
          } else {
            toast({
              title: "Attendance",
              description: `${schedule_res.message}`,
              status: "error",
            });
          }
        } catch (error: any) {
          toast({
            title: "Attendance",
            description: `${error.response.data.message}`,
            status: "error",
          });
        }
      } else {
        toast({
          title: "Attendance Upload",
          description: "Please fill all the fields",
          status: "info",
          duration: 2000,
        });
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box width="100hw">
          <TrDashboardHeader />
          <Box
            bg="#F9F8F8"
            minHeight={"100vh"}
            height="auto"
            width="100%"
            pt={"1.5rem"}
          >
            {!showSideNav && (
              <HStack
                overflowX="scroll"
                width={"100%"}
                height={"60px"}
                justifyContent={"space-around"}
                alignItems={"center"}
                fontSize={"13px"}
                padding={"0px 10px"}
                bg="white"
                className="scroll-hidden"
                mt="1.38rem"
                // flex={"no-wrap"}
              >
                {menuLinks.map((link, index) => (
                  <React.Fragment key={index}>
                    <Link
                      onClick={() => navigate(link.route)}
                      cursor={"pointer"}
                      textAlign={"center"}
                      alignContent={"center"}
                      wordBreak={"keep-all"}
                      height={"60px"}
                      width={"max-content"}
                      borderBottom={
                        activeLink(link.route, link.keywords).borderLeft
                      }
                      borderColor={
                        activeLink(link.route, link.keywords).borderColor
                      }
                      color={activeLink(link.route, link.keywords).textColor}
                    >
                      {link.text}
                    </Link>
                    {index < menuLinks.length - 1 && (
                      <Divider orientation="vertical" height="70%" />
                    )}
                  </React.Fragment>
                ))}
              </HStack>
            )}
            <Flex
              width="90%"
              mx="auto"
              pb="120px"
              pt={["50px", "60px", "60px", "80px"]}
            >
              {showSideNav && <TrainerSidenav />}
              <VStack
                width={{ lg: "80%", md: "80%", sm: "95%", base: "95%" }}
                mx="auto"
              >
                <HStack width={"100%"} height={"2rem"}>
                  <Text
                    as="span"
                    fontSize={["16px", "20px"]}
                    isTruncated
                    maxWidth={["180px", "200px", "350px", "500px"]}
                  >
                    {courseName && courseName.replaceAll(/"/g, "")}
                  </Text>
                  <Image src={rarrow} />
                  <Text as="span" fontSize={["16px", "20px"]} color={"#616161"}>
                    My Trainees
                  </Text>
                </HStack>
                <Box width={"100%"}>
                  {!availableCourseID && !loading ? (
                    <NotAvailableScreen />
                  ) : 
                    availableCourseID && !loading ? 
                     (
                      <Box
                        width="100%"
                        mx="auto"
                        pb={{
                          lg: "200px",
                          md: "150px",
                          sm: "110px",
                          base: "110px",
                        }}
                        px={{
                          lg: "2.8rem",
                          md: "2.4rem",
                          sm: "2rem",
                          base: "1.4rem",
                        }}
                        pt={{
                          lg: "3rem",
                          md: "2.6rem",
                          sm: "2rem",
                          base: "2rem",
                        }}
                        bg="white"
                      >
                        <Flex
                          justifyContent={"space-between"}
                          flexDirection={{
                            lg: "row",
                            md: "row",
                            sm: "column",
                            base: "column",
                          }}
                        >
                          <Text
                            color="#1E1E1E"
                            fontSize={{
                              lg: "28px",
                              md: "20px",
                              sm: "18px",
                              base: "18px",
                            }}
                            pb={["20px", "30px"]}
                            fontWeight="600"
                            as={"span"}
                            display={"flex"}
                            flexDirection={"row"}
                            gap={"8px"}
                          >
                            My Trainees{" "}
                            <span>
                              {" "}
                              <Image
                                src={trainees}
                                width={{
                                  lg: "auto",
                                  md: "auto",
                                  sm: "25px",
                                  base: "25px",
                                }}
                                height={{
                                  lg: "auto",
                                  md: "auto",
                                  sm: "25px",
                                  base: "25px",
                                }}
                                display={{
                                  lg: "flex",
                                  md: "none",
                                  sm: "flex",
                                  base: "flex",
                                }}
                              />
                            </span>
                          </Text>

                          <Flex
                            gap={{
                              lg: "auto",
                              md: "auto",
                              sm: "auto",
                              base: "8px",
                            }}
                            mb="1rem"
                            display={{
                              lg: "flex",
                              md: "flex",
                              sm: "none",
                              base: "none",
                            }}
                          >
                            <Button
                              title="download template for attendance"
                              variant={"outline"}
                              onClick={() => {
                                downloadAttendanceTemplate();
                              }}
                              borderRadius={"2px"}
                              p="7px"
                              colorScheme="red"
                              size="sm"
                            >
                              Download template
                            </Button>
                            <Button
                              p="7px"
                              colorScheme={"red"}
                              borderRadius={"2px"}
                              size="sm"
                              fontSize={{
                                lg: "12px",
                                md: "12px",
                                sm: "10px",
                                base: "10px",
                              }}
                              onClick={onOpen}
                            >
                              {" "}
                              Upload Attendance
                            </Button>
                          </Flex>
                        </Flex>

                        <Flex
                          alignItems="center"
                          mb="40px"
                          justifyContent="space-between"
                          width={{
                            lg: "100%",
                            md: "50%",
                            sm: "100%",
                            base: "100%",
                          }}
                          flexDirection={["column-reverse", "row"]}
                          gap={["1rem"]}
                        >
                          <InputGroup
                            color="brand.subtitle"
                            bg="white"
                            // mr="20px"
                            width={["100%", "250px"]}
                          >
                            <Input
                              placeholder="Search trainees "
                              fontSize={12}
                              size="sm"
                            />
                            <InputRightElement
                              h="1.9rem"
                              pointerEvents="none"
                              children={
                                <RiSearch2Line color="red" size="0.9rem" />
                              }
                            />
                          </InputGroup>
                          {/* <Flex justifyContent="space-between"> */}

                          <Flex
                            width={"100%"}
                            justifyContent={"flex-start"}
                            gap={["0.5rem", "1rem"]}
                            flexDirection={["column", "column", "row", "row"]}
                          >
                            <HStack display={["flex", "flex", "none", "none"]}>
                              <Button
                                title="download template for attendance"
                                variant={"outline"}
                                onClick={() => {
                                  downloadAttendanceTemplate();
                                }}
                                borderRadius={"2px"}
                                p="7px"
                                colorScheme="red"
                                size="sm"
                              >
                                Download template
                              </Button>
                              <Menu>
                                <MenuButton
                                  as={Button}
                                  rightIcon={<ChevronDownIcon />}
                                  colorScheme="gray"
                                  variant={"outline"}
                                  size="sm"
                                  fontSize={12}
                                  borderRadius={"2px"}
                                  width={["45%", "45%"]}
                                >
                                  More
                                </MenuButton>
                                <MenuList fontSize={12}>
                                  <MenuItem
                                    onClick={() => {
                                      goToAttendance();
                                    }}
                                  >
                                    View Attendance
                                  </MenuItem>
                                  <MenuItem onClick={onOpen}>
                                    Upload Attendance
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </HStack>

                            <Button
                              p="7px"
                              colorScheme={"red"}
                              size="sm"
                              fontSize={{
                                lg: "12px",
                                md: "12px",
                                sm: "10px",
                                base: "10px",
                              }}
                              display={{
                                lg: "flex",
                                md: "flex",
                                sm: "none",
                                base: "none",
                              }}
                              onClick={() => {
                                goToAttendance();
                              }}
                              variant={"outline"}
                              borderRadius="2px"
                            >
                              {" "}
                              View Attendance
                            </Button>
                            <Text textColor={"#616161"} marginLeft={"auto"}>
                              Number of Trainees{" "}
                              <Text
                                as="span"
                                fontWeight={"600"}
                                color={"black"}
                              >
                                {traineesList?.length || 0}
                              </Text>
                            </Text>
                          </Flex>
                        </Flex>
                        <TableContainer>
                          <Table variant="simple">
                            <Thead>
                              <Tr>
                                <Th> Trainee</Th>
                                <Th>Email</Th>
                                <Th> Trainee Code</Th>
                                {/* <Th>Attendance</Th> */}
                              </Tr>
                            </Thead>
                            <Tbody>
                              {traineesList &&
                                traineesList.map((each, index) => (
                                  <Tr key={index}>
                                    <Td>
                                      <HStack spacing={2}>
                                        <Avatar size={"sm"} name={each.name} />
                                        <Text fontSize="14px" color="#616161">
                                          {each.name}
                                        </Text>
                                      </HStack>
                                    </Td>
                                    <Td>
                                      <Text fontSize="14px" color="#616161">
                                        {each.email}
                                      </Text>
                                    </Td>
                                    <Td>
                                      {" "}
                                      <Text fontSize="14px" color="#616161">
                                        {each.code}
                                      </Text>
                                    </Td>
                                    {/* <Td>0</Td> */}
                                  </Tr>
                                ))}
                            </Tbody>
                          </Table>
                        </TableContainer>
                      </Box>
                    )
                  : null}
                </Box>
              </VStack>
            </Flex>
          </Box>
          <Modal
            isOpen={isOpen}
            scrollBehavior={"inside"}
            onClose={onClose}
            size={modalSize}
          >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Upload Attendance</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <form action="">
                  {filename ? (
                    <Box>
                      <Table variant="unstyled">
                        <Thead fontWeight="semibold">
                          <Tr color="brand.subtitle" fontSize={14}>
                            <Td>Filename</Td>
                            <Td>Type</Td>

                            <Td>Size</Td>
                          </Tr>
                        </Thead>

                        <Tbody>
                          <Tr fontSize={13} color="brand.subtitle">
                            <Td maxW="20em">{filename}</Td>
                            <Td>{filename}</Td>
                            <Td>{uploadFileSize}</Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </Box>
                  ) : (
                    <FormControl
                      mr={10}
                      isInvalid={formErrors.templateFile ? true : false}
                    >
                      <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                        Upload Attendance
                      </FormLabel>
                      <Text fontWeight="400" color="#959595" fontSize="14px">
                        Upload an excel template of the attendance.
                      </Text>

                      <input
                        type="file"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        name="template"
                        ref={inputRef}
                        onChange={(e) => handleFileChange(e)}
                        style={{ display: "none" }}
                      ></input>
                      <Input
                        cursor="pointer"
                        placeholder="No file selected"
                        defaultValue={filename}
                        mt="10px"
                        borderColor="#eeeeee"
                        fontSize={14}
                        bg="#fafafa"
                        onClick={() => inputRef?.current?.click()}
                        border="2px dashed"
                        borderRadius={2}
                      />
                      <FormErrorMessage>
                        {formErrors.templateFile}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                  <FormControl mt={3} mr={10} hidden>
                    <FormLabel fontWeight="600" color="#616161" fontSize={13}>
                      Physical Attendance Upload
                    </FormLabel>
                    <Text fontWeight="400" color="#959595" fontSize="14px">
                      Upload an image of the proof. (Not larger than 2MB)
                    </Text>

                    <input
                      accept="image/*"
                      type="file"
                      name="proof"
                      ref={inputProof}
                      style={{ display: "none" }}
                    ></input>
                    <Input
                      cursor="pointer"
                      placeholder="No file selected"
                      defaultValue={fileproofname}
                      mt="10px"
                      borderColor="#eeeeee"
                      fontSize={14}
                      bg="#fafafa"
                      onClick={() => inputProof?.current?.click()}
                      border="2px dashed"
                      borderRadius={2}
                    />
                  </FormControl>
                  {fileproofname && (
                    <Box mt="10px" mb="10px">
                      <Text>{fileproofname}</Text>
                    </Box>
                  )}
                  <FormControl
                    mb="15px"
                    mt="15px"
                    isInvalid={formErrors.cal_id ? true : false}
                  >
                    <FormLabel fontWeight="700" color="brand.3" fontSize={13}>
                      Course Event
                    </FormLabel>
                    <Select
                      variant="outline"
                      bg="inputText.500"
                      size="md"
                      placeholder="select course event"
                      value={cal_id}
                      onChange={(event) => setcal_id(event.target.value)}
                      name="courseevent"
                      fontSize={12}
                      color="brand.subtitle"
                    >
                      {calendarevents &&
                        calendarevents.map((each) => (
                          <option key={each.id} value={each.id}>
                            {" "}
                            {each.event}{" "}
                          </option>
                        ))}
                    </Select>
                    <FormErrorMessage>{formErrors.cal_id}</FormErrorMessage>
                  </FormControl>
                </form>
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="red"
                  variant="ghost"
                  mr={3}
                  onClick={onClose}
                >
                  Close
                </Button>
                <Button
                  size={"sm"}
                  fontSize="12px"
                  onClick={() => uploadAttendance()}
                  colorScheme={"red"}
                >
                  Upload
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      )}
    </>
  );
};

export default MyTrainees;

const NotAvailableScreen = () => {
  return (
    <Flex
      w="full"
      my="auto"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      gap={3}
      py={6}
      h="25rem"
    >
      <Box position="relative" h="auto" w="auto">
        <Image src={trainees} alt="empty" height="130px" width="130px" />
      </Box>

      <Box textAlign="center">
        <Text as="h2" color="#919191" fontWeight="semibold" fontSize="20px">
          Course not available for this session
        </Text>
        <Text color="black" fontSize="14px">
          No trainees to view
        </Text>
      </Box>
    </Flex>
  );
};
